import { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormControl, Stack, TextField } from '@mui/material';

type TAddBoardModalFormProps = Pick<
  UseFormReturn<{ name: string }>,
  'formState' | 'register'
> & {
  onSubmit: () => void;
};

const AddBoardModalForm: FC<TAddBoardModalFormProps> = ({
  formState,
  register,
  onSubmit,
}) => {
  const { errors } = formState;
  return (
    <FormControl component="form" fullWidth onSubmit={onSubmit}>
      <Stack spacing={1} direction="column">
        <TextField
          autoFocus
          label="Name"
          variant="standard"
          error={!!errors.name}
          helperText={errors.name && errors.name.message}
          required
          {...register('name')}
        />
      </Stack>
    </FormControl>
  );
};

export default AddBoardModalForm;
